export default __webpack_public_path__ + "static/media/banner_mob_rosa_1.dbf8af6b.jpg";